import { render, staticRenderFns } from "./expense-actions.vue?vue&type=template&id=8dc25d68&scoped=true&"
import script from "./expense-actions.vue?vue&type=script&lang=js&"
export * from "./expense-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc25d68",
  null
  
)

export default component.exports